var React = require('react');

function Unlock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.463 8.013a.894.929 0 0 1 .898.933v5.594a.894.929 0 0 1-.898.933H1.487a.894.929 0 0 1-.898-.933V8.945a.894.929 0 0 1 .898-.933h.299V4.907a4.034 4.19 0 0 1 1.233-3.075 4.176 4.337 0 0 1 5.919 0 4.034 4.19 0 0 1 1.23 3.074.606.63 0 0 1-.598.621h-.598a.606.63 0 0 1-.598-.621 2.306 2.395 0 0 0-.702-1.758 2.393 2.485 0 0 0-3.384 0 2.306 2.395 0 0 0-.701 1.758v3.106z"}));
}

Unlock.defaultProps = {"viewBox":"0 0 12 16"};

module.exports = Unlock;

Unlock.default = Unlock;
